export default __webpack_public_path__ + "static/media/project1.aa6253be.png";